import { error, finish } from '../../../modules/related-contingency/actions/add-markets';
import { request as getMarketsForRcTags } from '../../../modules/related-contingency/actions/get-markets-for-rc-tag';

import api from '../../../api';

export function request(dispatch, {
    tagId,
    eventId,
    marketId,
    query,
    getAll
}) {
    api.del(`/contingencies/tag-content/${tagId}/${eventId}/${marketId}`)
        .then(res => {
            dispatch(finish(res));
            if (getAll) {
                dispatch(getMarketsForRcTags(tagId, query));
            }
        }).catch(err => {
            dispatch(error(err));
        });
}
